import { match } from 'path-to-regexp';
import { logError } from '../logError';

export default function parseTrackingPageUrl(pathname) {
  const urlMatch = match('/:trackingPageId/:orderId/:zipCode?', {
    decode: decodeURIComponent,
  });

  const result = urlMatch(pathname);

  if (!result) {
    logError(new Error('Invalid url'), { pathname });
    return {};
  }

  const { trackingPageId, orderId, zipCode } = result.params;

  return {
    trackingPageId,
    orderId,
    zipCode,
  };
}
